import { createFileRoute } from '@tanstack/react-router';
import { AdminCrossdockCostPage } from '@/features/admin/admin-crossdock-cost-page';

export const Route = createFileRoute('/admin/crossdock-cost/')({
  component: AdminCrossdockCostRoute,
});

function AdminCrossdockCostRoute() {
  return <AdminCrossdockCostPage />;
}
